import styled from 'styled-components';

export const Container = styled.div`    
    width: 100%;
    min-height: 61px;
    background-color: #F9F9F9;

    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 10px;

    flex-wrap: wrap;

    row-gap: 10px;

    img.notification__close {
        flex: 1 1 0;
        max-width: 15px;
        max-height: 15px;
        margin-right: 15px;
        cursor: pointer;
    }

    .notification__message {
        flex: 2 1 0;
        display: flex;
        align-items: center;
        max-width: max-content;

        img{
            max-width: 45px;
        }

        span {
            font-size: 10px;
            line-height: 16px;
            font-weight: bold;
            margin-left: 10px;
        }
    }

    button.notification__action {
        border: none;
        background-color: #EE3B24;
        border-radius: 4px;
        width: 72px;
        width: max-content;
        height: 29px;
        margin-left: 15px;

        font-size: 12px;
        font-weight: bold;
        color: #fff;
        text-transform: capitalize;
    }    
`